module.exports = __webpack_public_path__ + "images/help/avatars/dragon-56fd3fc578cbf59f68d5599b35c06898.jpg";